import React from 'react';
import PropTypes from 'prop-types';
import { HeadingF, ProductContent } from 'DesignSystem/Typography';

const ZeroStateModalIcon = ({ heading, hideArrow, imagePath, number }) => (
  <React.Fragment>
    <div className="zero-state-modal-icon">
      <div>
        <img
          alt="zero state icon"
          className="zero-state-icon"
          src={imagePath}
        />
      </div>
      <div>
        <HeadingF>{heading}</HeadingF>
        <ProductContent className="zero-state-product-content">
          <span>{`${number}.`}</span>
          {heading}
        </ProductContent>
      </div>
    </div>
    {!hideArrow && (
      <div className="zero-state-modal-icon-arrow-wrapper">
        <img
          alt="Arrow"
          className="zero-state-modal-icon-arrow"
          src="images/self-serve-builder/modals/zero-state-icons/arrow-2x.png"
        />
      </div>
    )}
  </React.Fragment>
);

ZeroStateModalIcon.defaultProps = {
  hideArrow: false,
};

ZeroStateModalIcon.propTypes = {
  heading: PropTypes.string.isRequired,
  hideArrow: PropTypes.bool,
  imagePath: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
};

export default ZeroStateModalIcon;



// WEBPACK FOOTER //
// ./src-react/SelfServeModals/ZeroStateModal/ZeroStateModalIcon.jsx